import { render } from "./SetupRouterLink.vue?vue&type=template&id=607a8206"
import script from "./SetupRouterLink.vue?vue&type=script&lang=js"
export * from "./SetupRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__